<template>
  <div
    class=main--text>
    <v-lp-tool-bar/>
    <v-container
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=6>
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdMSCUiXfqZAJm_dROTy7n_9PJ2q0rtOBfLblMGZWRJl8b1Ag/viewform?embedded=true" width="640" height="1079" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
        </v-col>
      </v-row>
    </v-container>
    <v-lp-footer/>
  </div>
</template>


<script>
import VLpToolBar from '@/components/organisms/lp/VLpToolBar.vue'
import VLpFooter from '@/components/organisms/lp/VLpFooter.vue'
export default {
  components: {
    VLpToolBar,
    VLpFooter
  }
}
</script>
